var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBroken = function SvgBroken(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "broken_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f6145a",
    d: "M0 0h72.226v73.536H0z",
    "data-name": "Rectangle 1024"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2939"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2938"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2937"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#f6145a",
    clipPath: "url(#broken_svg__a)",
    "data-name": "Group 2936",
    transform: "translate(3.887 3.129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.34 49.357 47.285 34.942 29.67 48.161l-15.686-9.218L0 44.612v19.415c0 5.252 3.782 9.509 8.448 9.509h55.33c4.665 0 8.448-4.257 8.448-9.509V41.439Z",
    "data-name": "Path 6128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.343 31.018 15.025 7.553 18.272-11.73 14.966 12.26 9.62-6.591V9.935a8.3 8.3 0 0 0-8.448-8.134H8.448A8.3 8.3 0 0 0 0 9.935v26.057Z",
    "data-name": "Path 6129"
  })))))));
};
export default SvgBroken;